// src/app/shared/auth/http-context-tokens.ts
import { HttpContextToken } from '@angular/common/http';

// Creiamo un token che useremo per "marcare" le richieste che non necessitano di autenticazione.
export const BYPASS_AUTH = new HttpContextToken<boolean>(() => false);
